import React from 'react';
import SEOHead from '../components/SEOHead';
import './Socials.css';

const Socials = () => {
  const officialLinks = [
    {
      name: "Instagram",
      url: "https://www.instagram.com/youronetimer/", // TO BE ADDED - placeholder for now
      icon: "📷",
      description: "App updates, user stories, and productivity tips",
      handle: "@onetimerapp"
    },
    {
      name: "X",
      url: "https://x.com/youronetimer", // TO BE ADDED - placeholder for now
      icon: "🐦", 
      description: "Quick updates, announcements, and community highlights",
      handle: "@onetimerapp"
    },
    {
      name: "TikTok",
      url: "https://www.tiktok.com/@youronetimer", // TO BE ADDED - placeholder for now
      icon: "🎵",
      description: "Productivity tips and time-tracking inspiration",
      handle: "@onetimerapp"
    },
  ];

  return (
    <>
      <SEOHead
        title="OneTimer Social Media - Follow Us"
        description="Follow OneTimer on social media for app updates, productivity tips, and community highlights. Join our growing community!"
        keywords="OneTimer social media, follow OneTimer, productivity community, app updates"
        path="/socials"
      />
      <div className="socials-container">
      <div className="socials-header">
        <h1>follow our socials</h1>
        <p className="subtitle">Stay connected with the OneTimer community</p>
      </div>
      
      <div className="socials-content">
        
        <div className="social-platforms">
          <div className="platforms-grid">
            {officialLinks.map((platform, index) => (
              <a 
                key={index}
                href={platform.url}
                className="platform-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="platform-icon">{platform.icon}</div>
                <div className="platform-info">
                  <div className="platform-name">{platform.name}</div>
                  <div className="platform-handle">{platform.handle}</div>
                  <div className="platform-description">{platform.description}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
        
        
       
      </div>
      </div>
    </>
  );
};

export default Socials;